export default __webpack_public_path__ + "static/media/certificate-of-sponsorship.7ae33a4e.png";